import React from 'react';
import './FoodsTable.scss';
import TableRowActionMenu from '../../../BaseComponents/TableRowActionMenu';
import { Food } from '../../../../types/apiGeneratedTypes';
import { useDispatch } from 'react-redux';
import {
  setFoodToEdit,
  setFoodToDelete,
  changeDeleteFoodModalVisibility,
  changeModalVisibility,
  setFoodToView,
  setFoodsList
} from '../../../../store/foodsSlice';

interface IProps {
  foodData: Food;
  foodsList: Food[];
}

const FoodsTableMedicalLibraryRow: React.FC<IProps> = ({
  foodData,
  foodsList
}) => {
  const dispatch = useDispatch();
  const onOptionClick = async (id: number, action: string) => {
    if (action === 'edit') {
      dispatch(setFoodToEdit(foodData));
      dispatch(changeModalVisibility(true));
    }
    if (action === 'delete') {
      dispatch(setFoodToDelete(foodData));
      dispatch(changeDeleteFoodModalVisibility(true));
      dispatch(
        setFoodsList({ foods: foodsList.filter((food) => food.id !== id) })
      );
    }
    if (action === 'view') {
      dispatch(setFoodToView(foodData));
    }
  };

  return (
    <div className='table-row recommendations-table-row'>
      <div className='test-image'>
        <img
          src={foodData.image_url ?? foodData.image}
          alt='food'
          width='100'
          height='100'
        />
      </div>
      <div className='test-title'>{foodData.name}</div>
      <div className='test-description'>{foodData.description}</div>
      <div className='actions'>
        <TableRowActionMenu
          options={[
            { key: 'edit', value: 'Edit' },
            { key: 'delete', value: 'Delete' },
            { key: 'view', value: 'View' }
          ]}
          id={foodData.id}
          onActionMenuClick={onOptionClick}
        />
      </div>
    </div>
  );
};

export default FoodsTableMedicalLibraryRow;
